import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  hasUnread: false,
  latestVersion: null,
  releaseDate: null,
  file: null
};

export const updateReleaseNotesAction = createAction("releaseNotes/update");
export const markReleaseNotesReadAction = createAction("releaseNotes/markRead");

export default createReducer(initialState, (builder) => {
  builder
    .addCase(updateReleaseNotesAction, (state, action) => {
      return { ...state, ...action.payload };
    })
    .addCase(markReleaseNotesReadAction, (state) => {
      state.hasUnread = false;
    });
});
